import ToggleSwitch from "../../admin/sidebar/items/ToggleSwitch";
import * as React from "react";
import {useMicrosite} from "./Microsite";
import styles from "./Microsite.module.scss";
import mainGridPageStyles from "../../../pages/styles/MainGridPage.module.scss";
import classNames from 'classnames';

const toggleClassName = classNames({
    [mainGridPageStyles.hiddenWhenSmall]: true,
    [styles.toggle]: true,
})

export function MicrositeToggle(props: {displayText: boolean}) {
    const {canShowMicrosite, shouldShowMicrosite, toggleShouldShowMicrosite} = useMicrosite();

    return <div className={toggleClassName}>
        <ToggleSwitch
            enabled={canShowMicrosite}
            on={shouldShowMicrosite}
            onClick={toggleShouldShowMicrosite}
            aria-label={"Toggle microsite navigation. Microsites can be enabled only on pages with enough content."}
        />
        {props.displayText && <div>Micro-Site</div>}
    </div>
}
